export default {
    index:{
        helpTitle:'帮助',
        helpTips0:'按键6种自定义模式介绍:',
        helpTips1:'1.普通键:将CwKeyLink某一按键按键定义为如1、2、3、a、b、c、?、空格等可输入的普通按键',
        helpTips1_1:'注意:普通键如果输入大写字母或!@#$%等按键 实际是通过Shift+对应按键触发!',
        helpTips2:'2.功能键:将CwKeyLink某一按键按键定义为Ctrl、Alt、Win、Command、回车等功能按键',
        helpTips2_1:'F13-F24为特殊功能按键,普通键盘并没有,可以作为软件内的自定义快捷键,防冲突使用!',
        helpTips3:'3.多媒体键:将CwKeyLink某一按键按键定义为音量加、亮度加、打开浏览器等多媒体按键',
        helpTips4:'4.组合键:将CwKeyLink某一按键按键定义为2键-5键组合,如一键Ctrl+c、一键Win+l、一键Ctrl+Alt+Delete等组合按键',
        helpTips5:'5.字符串:将CwKeyLink某一按键按键定义为输入字符串,如一键输入用户名、一键输入select * from等',
        helpTips6:'★6.鼠标:选择对应按键,同时勾选后面的-仿真鼠标 (作为鼠标使用只需要左右按键)★',
        helpButton:'查看帮助',
        titleLeft:'---------------  设置左键  --------------',
        titleright:'---------------  设置右键  --------------',
        titleNo:'GPIO-5',
        connButtonText1:'连接CwKeyLink',
        keyAllLabel:'三键同按',
        keyAllTrue:'开',
        keyAllFalse:'关',
        changeLog5:'2024.11.5 固件更新',
        changeLog4:'2024.7.12 软件更新',
        changeLog3:'2023.6.16 软件更新',
        changeLog1:'2023.5.4 软件更新',
        changeLog1_1:'如何更新固件',
        changeLog2:'2023.4.25 软件更新',
        changeLog2_1:'如何更新',
        upset:'★ CwKey 自动键组装图 ★',
        upset_url:'https://www.srac.cn/tool/cwkeylink/upset',
        uphex:'★ CwKeyLine USB电脑连接器如何更新固件 ★',
        CwKey_soft_title:'CW摩尔斯电码训练软件',
        CwKey_lakey_title:'Lakey software (Win7/10/11)',
        CwKey_lakey_title2:'VBand 在线训练 (左右键需要设置成-左Ctrl和右Ctrl)',
        videoText:'测试工具',
        keyTest:'在线键盘测试网站',
        mouseTest:'在线鼠标测试网站',
        openSource:'开源项目',
        backToIndex:'回到首页',
        submit:'提交设置',
        browserErr:'请使用103以上版本Chrome或Edge浏览器,https方式访问此页面!',
        firmwareErr:'当前连接的CwKeyLink不是最新固件A<br/>',
        firmwareErrv5:'当前连接的CwKeyLink不是最新固件B<br/>',
        firmwareErrv6:'当前连接的CwKeyLink不是最新固件C<br/>',
        tip:'提示',
        updateHelp:'更新教程',
        updateNo:'暂不更新,返回',
        redirecting:'正在跳转....请稍后',
        connFirst:'请先连接设备',
        disconnect:'断开连接',
        success:'设置成功!',
        firmwareErr1:'当前连接的CwKeyLink不是最新固件,请更新新版本!<br/><br/>',
        updateNo1:'暂不更新,先改键(跳转到旧版改键页)',
        conError1:'端口已占用,连接失败!',
        conError2:'连接失败,原因:',
        conError3:'断开连接失败!请刷新页面!',
        howtoaddress:'https://www.srac.cn/tool/cwkeylink/uphex',
        web_end_1:'河北 · 石家庄业余无线电 SRAC',
        web_end_2:'Shijiazhuang Radio Amateurs Club',
        web_end_3:'-未使用-',
        web_end_4:'Copyright 2008-2024 SARC.cn',
    },
    keyConfig:{
        keyDes1:'普通键',
        keyDes2:'功能键',
        keyDes3:'多媒体键',
        keyDes4:'组合键',
        keyDes5:'字符串',
        keyDes6:'鼠标',
        select:'请选择',
        mix1:'增加功能键',
        mix2:'增加普通键',
        mix3:'删除组合键',
        mix4:'重置组合键',
        mix5:'常用组合键',
        mixtip:'以下为常见组合键,可快速设置,不知道设成啥可以看看,不定期更新',
        mixcommon1:'组合键',
        mixcommon2:'描述',
        mixcommon3:'操作',
        set:'设置',
        inputErr:'输入错误',
        selectErr:'选择错误',
        mixErr:'组合键至少为2键组合!',
        mixErr1:'组合键第',
        mixErr2:'位选择错误',
        mixErr3:'位输入错误',
        textErr:'字符串不能为空',
        textErr1:'字符串输入错误，无此键位',
        setErr:'设置错误',
        delErr:'已无法再删除!',
        mixMaxErr:'最多支持5个按键组合!',
        mixAdd:'请增加功能键或普通键',
        mixMax5:'以上所有按键组合,最多支持5键',
        holdTip:'长按时连续点击',
        holdPressTip:'仿真鼠标',
        stringEnter:'输入后按Enter换行',
        move:'移动距离',
        strong:'力度',
        mouses:['左键点击','中键点击','右键点击','随机移动位置','向上移动','向下移动','向左移动','向右移动','向上滚轮','向下滚轮'],
        functionkeys:["左Ctrl", "左Shift", "左Alt", "左Win/Command", "右Ctrl", "右Shift", "右Alt", "右Win/Command", "向上", "向下", "向左", "向右", "Backspace", "Tab", "回车Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(小键盘)", "*(小键盘)", "-(小键盘)", "+(小键盘)", "Enter(小键盘)", "1(小键盘)", "2(小键盘)", "3(小键盘)", "4(小键盘)", "5(小键盘)", "6(小键盘)", "7(小键盘)", "8(小键盘)", "9(小键盘)", "0(小键盘)", ".(小键盘)"],
        mediakeys:["电源键", "睡眠键", "录制", "快进", "回放", "下一首", "上一首", "停止播放", "播放/暂停", "暂停", "静音", "音量增加", "音量减少","屏幕亮度增加","屏幕亮度减少","屏保","打开音乐软件","打开Email软件","打开计算器","打开文件管理器","打开浏览器","浏览器后退","浏览器前进","浏览器刷新","浏览器书签"]
    }
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js